import { ProductRuleContextProvider } from "./use-productRuleData";
import { ForeignShopRuleContextProvider } from "./use-foreignShopRuleData";
import { ActionRuleContextProvider } from "./use-actionRuleDate";
import { OptionsContextProvider } from "./use-optionsData";

export default function EditorProvider({ children }) {
     return (
          <ProductRuleContextProvider>
               <ForeignShopRuleContextProvider>
                    <ActionRuleContextProvider>
                         <OptionsContextProvider>
                              { children }
                         </OptionsContextProvider>
                    </ActionRuleContextProvider>
               </ForeignShopRuleContextProvider>
          </ProductRuleContextProvider>
     );
}